var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ziaooqv82a",
    d: "M0 0H24V24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.000000, -460.000000) translate(24.000000, 316.000000) translate(78.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vbvz5d3rib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ziaooqv82a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#138518",
    d: "M9 12v2H7v-2h2zm0 4v2H7v-2h2zm2-4v2h2v-2h-2zm2 4v2h-2v-2h2zm2-4v2h2v-2h-2zm2 4v2h-2v-2h2zm2 6H5c-1.103 0-2-.897-2-2V6c0-1.103.897-2 2-2h2V2h2v2h6V2h2v2h2c1.103 0 2 .897 2 2v14c0 1.103-.897 2-2 2zm0-14V6H5v2h14zm0 2l.001 10H5V10h14z",
    mask: "url(#vbvz5d3rib)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalendar);
export default __webpack_public_path__ + "static/media/green-calendar.4d2cee49.svg";
export { ForwardRef as ReactComponent };